import { faArrowRight, faLink } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import './Project.css';

const Project = ({ p, getProjectById }) => {

    const { _id, name, coverImg, title, des, url } = p;


    return (
        <div className='custom_style mx-auto md:w-full shadow-lg rounded-lg w-5/6 '
            data-aos="fade-up"
            data-aos-duration="800"
        >
            <div className=' overflow-hidden'>
                <img src={coverImg} className="rounded-tl-lg hover:scale-105 duration-150 rounded-tr-lg" alt="Project_Picture" />
            </div>
            <div className='p-3 bg-white'>
                <h2 className='text-2xl font-semibold'>   {name}</h2>
                <h2 className='text-primary'> <FontAwesomeIcon className='text-xs' icon={faLink}></FontAwesomeIcon> <a href={url} target="_blank" > View Project</a> </h2>
                <h2 className='text-md font-semibold text-green-500'>{title}</h2>
                 <p className='text-gray-500'> {des.length > 126 ? des.slice(0, 125) + '...': des }</p>
                <button className='btn w-full mt-5 bg-primary border-0 text-white' onClick={() => getProjectById(_id)}>Project Details <FontAwesomeIcon className='ml-2' icon={faArrowRight} /> </button>
            </div>
        </div>
    );
};

export default Project;